import { useLocation } from 'react-router-dom';
import { Services } from 'services';
import { useExternalOAuthCallback } from 'services/auth/use-external-oauth-callback';

export const Auth0SsoCallback = (): null => {
  const { search } = useLocation();
  const { auth0SsoLogin } = Services.Auth.useAuth0SsoLogin();

  useExternalOAuthCallback(search, auth0SsoLogin);

  return null;
};
